import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import {ProcessoIdentificacaoPeticaoInicialService} from './processo-identificacao-peticao-inicial.service';
import {ComponentsModule} from '../components/components.module';
import { ProcessoIdentificacaoPeticaoInicialDadosComponent } from './processo-identificacao-peticao-inicial-dados/processo-identificacao-peticao-inicial-dados.component';
import { ProcessoDocumentoModule } from '../processo-documento/processo-documentos.module';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
    ProcessoDocumentoModule
  ],
  declarations: [
    ProcessoIdentificacaoPeticaoInicialDadosComponent
  ],
  exports: [
    ProcessoIdentificacaoPeticaoInicialDadosComponent
  ],
  providers: [
    ProcessoIdentificacaoPeticaoInicialService,
  ]
})
export class ProcessoIdentificacaoPeticaoInicialModule { }
